import { asyncToGenerator as _asyncToGenerator } from "../_virtual/_rollupPluginBabelHelpers.js";
import _pt from 'prop-types';
import { useEffect } from 'react';
import { jsx } from '@emotion/core';
import { Button } from '@appfolio/react-gears';
import useStores from "../hooks/useStores.js";
import { saveAs } from 'file-saver';
import useCreateDocumentDownload from "../hooks/api/useCreateDocumentDownload.js";

var DocumentDownloadButton = function DocumentDownloadButton(_ref) {
  var documentId = _ref.documentId,
      title = _ref.title,
      onError = _ref.onError;

  var _useStores = useStores(),
      pdfStore = _useStores.pdfStore,
      signatureStore = _useStores.signatureStore;

  var _useCreateDocumentDow = useCreateDocumentDownload(title),
      isLoading = _useCreateDocumentDow.isLoading,
      createDownload = _useCreateDocumentDow.createDownload,
      error = _useCreateDocumentDow.error;

  useEffect(function () {
    if (error && onError) onError(error);
  }, [onError, error]);

  var handleDownload = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var file;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return createDownload(documentId, pdfStore.fields, signatureStore.signature);

            case 2:
              file = _context.sent;

              if (file) {
                saveAs(file);
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleDownload() {
      return _ref2.apply(this, arguments);
    };
  }();

  return jsx(Button, {
    disabled: isLoading,
    color: "secondary",
    tag: "button",
    onClick: handleDownload
  }, "Print to PDF");
};

DocumentDownloadButton.displayName = "DocumentDownloadButton";
DocumentDownloadButton.propTypes = {
  documentId: _pt.string.isRequired,
  title: _pt.string,
  onError: _pt.func,
  children: _pt.node
};
DocumentDownloadButton.displayName = 'DocumentDownloadButton';
export default DocumentDownloadButton;